import { DateTime } from 'luxon';

export const generateTimeOptions = () => {
  const slots = [];
  for (let i = 0; i < 24 * 60; i += 30) {
    const hour = Math.floor(i / 60);
    const minute = i % 60;
    const value = `${String(hour).padStart(2, '0')}:${String(minute).padStart(
      2,
      '0'
    )}`;
    slots.push({
      value,
      label: DateTime.local()
        .set({ hour, minute })
        .toLocaleString(DateTime.TIME_SIMPLE),
    });
  }
  slots.push({ value: '23:59', label: 'End of day' });
  return slots;
};
